import { useEffect } from 'react'
import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'
import BottomSheetContent from './BottomSheetContent'
import { MUTUAL_FUND_DETAIL_IMAGE_URL } from '../../constants'
import { HelpDialogPassage } from './HelpDialogPassage'

type BottomSheetWrapperPropTypes = {
  onDismiss: () => void
  ScreenName: string
}

const BODY_CLASS = 'text-[#6a6e6e] text-sm font-normal'
const TITLE_CLASS = 'text-[#232323] text-sm font-medium'

const PERFORMANCE_ITEMS = [
  { title: 'In-form', body: 'Among the top performers' },
  { title: 'On-track', body: 'Performing better than most funds' },
  { title: 'Off-track', body: 'Falling behind most funds' },
  { title: 'Out-of-form', body: 'Among the lowest performers' }
] as const

export const PerformanceBottomSheet = ({ onDismiss, ScreenName }: BottomSheetWrapperPropTypes) => {
  const heading = 'Performance'
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent
      heading={heading}
      logoSrc={`${MUTUAL_FUND_DETAIL_IMAGE_URL}/performance-bottom-sheet-icon.svg`}
      onDismiss={onDismiss}
    >
      <div className='leading-[120%] flex flex-col gap-4'>
        <HelpDialogPassage accessibleLabel='Every month, funds are evaluated based on their performance within their category and classified into one of these four:'>
          <span className={BODY_CLASS}>
            Every month, funds are evaluated based on their performance within their category and classified into one of
            these four:
          </span>
        </HelpDialogPassage>
        <ul className='list-disc pl-4 m-0 flex flex-col gap-2'>
          {PERFORMANCE_ITEMS.map((item) => (
            <li key={item.title} aria-label={`${item.title}: ${item.body}`}>
              <span aria-hidden='true'>
                <span className={TITLE_CLASS}>{item.title}:</span>
                <span className={BODY_CLASS}> {item.body}</span>
              </span>
            </li>
          ))}
        </ul>
        <HelpDialogPassage accessibleLabel='This classification is derived from learnings of 20+ years of data, verified by our experts.'>
          <span className={BODY_CLASS}>
            This classification is derived from learnings of 20+ years of data, verified by our experts.
          </span>
        </HelpDialogPassage>
        <HelpDialogPassage accessibleLabel='Refer to our SIP and lump sum recommendations and keep your portfolio in its best shape.'>
          <span className={BODY_CLASS}>
            Refer to our SIP and lump sum recommendations and keep your portfolio in its best shape.
          </span>
        </HelpDialogPassage>
      </div>
    </BottomSheetContent>
  )
}
